import isString from 'lodash/isString';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { exception } from '@/exceptions/Exceptions';

const Countries = require('@/resources/countries.json');

export const formatTelephoneNumber = (telephone, countryCode = null) => {
    if (!telephone) exception('Invalid telephone number');

    telephone = telephone.split(' ').join('');

    if (!telephone || !isString(telephone) || telephone.length < 10) exception('Invalid telephone number');

    if (!countryCode) countryCode = process.env.VUE_APP_COUNTRY_ISO;

    // Phone library requires country ISO 2 not ISO 3.
    const countryData = Countries.filter(item => item.iso === countryCode);
    countryCode = countryData[0].iso2;
    let formattedTelephoneNumber = parsePhoneNumberFromString(telephone, countryCode);

    return formattedTelephoneNumber;
};

export const isTelephoneNumberValid = (telephone, countryCode = null) => {
    try {
        let formattedTelephoneNumber = formatTelephoneNumber(telephone, countryCode);

        return formattedTelephoneNumber.isValid();
    } catch (error) {
        return false;
    }
};

export const telephoneNumberInternationlFormat = (telephone, countryCode = null) => {
    let formattedTelephoneNumber = formatTelephoneNumber(telephone, countryCode);

    return formattedTelephoneNumber.format('INTERNATIONAL');
};
